module.exports = __webpack_public_path__ + "img/google-store.240b212b.png";